export const SIDEBAR_CLOCK_MODES = ["utc", "local", "hidden"] as const;
export type SidebarClockMode = (typeof SIDEBAR_CLOCK_MODES)[number];

const STORAGE_KEY = "cpl_sidebar_clock_mode";

export function isSidebarClockMode(value: unknown): value is SidebarClockMode {
  return typeof value === "string" && (SIDEBAR_CLOCK_MODES as readonly string[]).includes(value);
}

export function readStoredSidebarClockMode(): SidebarClockMode {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (isSidebarClockMode(stored)) return stored;
  } catch {
    /* ignore */
  }
  return "utc";
}

export function writeStoredSidebarClockMode(mode: SidebarClockMode): void {
  try {
    localStorage.setItem(STORAGE_KEY, mode);
  } catch {
    /* ignore */
  }
}
